const getDefaultStateIspezioni = () => {
  return {
    circoloIspezioni: null,
    nomeCircoloIspezioni: null,
    bozzaIspezioni: null,
    rowsToSkipIspezioni: 0,
    fetchRowsIspezioni: 25,
    currentPageIspezioni: 1,
    sortColumnIspezioni: "promoter",
    sortOrderIspezioni: "asc",
  };
};
const state = getDefaultStateIspezioni();

const getters = {
  circoloIspezioni: (state) => state.circoloIspezioni,
  nomeCircoloIspezioni: (state) => state.nomeCircoloIspezioni,
  bozzaIspezioni: (state) => state.bozzaIspezioni,
  rowsToSkipIspezioni: (state) => state.rowsToSkipIspezioni,
  fetchRowsIspezioni: (state) => state.fetchRowsIspezioni,
  currentPageIspezioni: (state) => state.currentPageIspezioni,
  sortColumnIspezioni: (state) => state.sortColumnIspezioni,
  sortOrderIspezioni: (state) => state.sortOrderIspezioni,
};

// const actions = {};
const mutations = {
  setcircoloIspezioni: (state, value) => {
    state.circoloIspezioni = value;
  },
  setbozzaIspezioni: (state, value) => {
    state.bozzaIspezioni = value;
  },
  setnomeCircoloIspezioni: (state, value) => {
    state.nomeCircoloIspezioni = value ? value : null;
  },
  setFetchRowsIspezioni: (state, value) => {
    state.currentPageIspezioni = 1;
    state.rowsToSkipIspezioni = 0;
    state.fetchRowsIspezioni = value;
  },
  setCurrentPageIspezioni: (state, value) => {
    state.currentPageIspezioni = value;
    state.rowsToSkipIspezioni = parseInt(
      (state.currentPageIspezioni - 1) * state.fetchRowsIspezioni
    );
  },
  setSortColumnIspezioni: (state, value) => {
    state.sortColumnIspezioni = value;
  },
  setSortOrderIspezioni: (state, value) => {
    state.sortOrderIspezioni = value;
  },
  setCategoriaIspezioni: (state, value) => {
    state.id_categoriaIspezioni = value;
  },
  resetFiltersIspezioni: (state) => {
    Object.assign(state, getDefaultStateIspezioni());
  },
  resetRowsToSkipIspezioni: (state) => {
    state.currentPageIspezioni = 1;
    state.rowsToSkipIspezioni = 0;
  },
};

export default {
  state,
  getters,
  mutations,
};
